<template>
  <main class="terms-conditions">
    <b-container fluid>
      <b-row>
        <!-- <b-col sm="2" class="elements">

        </b-col> -->
        <b-col>
          <div class="content">
            <h1 class="title">{{ title }}</h1>
            <ul class="term-one" v-for="term in terms" :key="term.id">
              <li>{{ term.texts }}</li>
            </ul>

            <ol class="term-two">
              <li v-for="term in termstwo" :key="term.id">
                <span>{{ term.termtitle }}</span>
                <p>{{ term.texts }}</p>
                <ul v-if="term.active" v-for="termdot in term.termdots" :key="termdot.id">
                  <li>{{ termdot.text }}</li>
                  <ul
                    v-if="termdot.active"
                    v-for="termdot1 in termdot.termdots1"
                    :key="termdot1.id"
                  >
                    <li>{{ termdot1.text }}</li>
                  </ul>
                </ul>
              </li>
            </ol>
          </div>
          <img
            src="@/assets/depreciated/rebrand/termscondition/termscondition-bg.png"
            alt="bg"
            class="background-terms-condition web"
          />
          <img
            src="@/assets/depreciated/rebrand/termscondition/termscondition-bg-mob.png"
            alt="bg"
            class="background-terms-condition mob"
          />
        </b-col>
        <!-- <b-col sm="2" class="elements">

        </b-col> -->
      </b-row>
    </b-container>
    <img
      src="@/assets/depreciated/rebrand/termscondition/left-border.png"
      alt="bg"
      class="left-border"
    />
    <img
      src="@/assets/depreciated/rebrand/termscondition/terms-grid.svg"
      alt="bg"
      class="terms-grid-left"
    />
    <img
      src="@/assets/depreciated/rebrand/termscondition/terms-grid-1.svg"
      alt="bg"
      class="terms-grid-left-1"
    />
    <img
      src="@/assets/depreciated/rebrand/termscondition/terms-grid-2.svg"
      alt="bg"
      class="terms-grid-left-2"
    />
    <img
      src="@/assets/depreciated/rebrand/termscondition/left-border.png"
      alt="bg"
      class="left-border bottom"
    />
    <img
      src="@/assets/depreciated/rebrand/termscondition/right-border.png"
      alt="bg"
      class="right-border"
    />
    <img
      src="@/assets/depreciated/rebrand/termscondition/terms-grid.svg"
      alt="bg"
      class="terms-grid"
    />
    <img
      src="@/assets/depreciated/rebrand/termscondition/terms-grid-1.svg"
      alt="bg"
      class="terms-grid-right-1"
    />
    <img
      src="@/assets/depreciated/rebrand/termscondition/terms-grid-2.svg"
      alt="bg"
      class="terms-grid-right-2"
    />
    <img
      src="@/assets/depreciated/rebrand/termscondition/right-border.png"
      alt="bg"
      class="right-border bottom"
    />
  </main>
</template>
<script>
export default {
  name: "TermsAndCondition",
  data() {
    return {
      title: "TERMS AND CONDITIONS",
      terms: [
        {
          id: 0,
          texts: `SNKRHUD, INC. (‘SNKRHUD” or “we”) builds upon decades of passion for sneakers, streetwear, and
culture. Designed as a playground for creatives, a center of knowledge for sneakerheads new and old,
and the epicenter of the next revolution in sneaker collecting. Building an NFT-based community with a
play-to-earn gaming component is about much more than flexing, but rather empowering our Residents
to build their own sneaker legacies.As part of our community, please first carefully read our Terms of
Service (“Terms”).`
        },
        {
          id: 1,
          texts: `These Terms govern any access or use of the website at https://snkrhud.com/, https://
sneakerrater.com/, and any other web site, mobile application, marketplace or application program
interface operated or made available by SNKRHUD (the “Platform”) as well as any services provided on
or through the Platform (“Services”). By using our Services, you agree to these Terms. If you do not agree
to these Terms, do not use our Services.`
        },
        {
          id: 2,
          texts: `We may make changes to these Terms from time to time. If we make changes, we will provide you with
notice of such changes, such as by sending an email, providing a notice through our Services or
updating the date at the top of these Terms. Unless we say otherwise in our notice, the amended Terms
will be effective immediately, and your continued use of our Services after we provide such notice will
confirm your acceptance of the changes. If you do not agree to the amended Terms, you must stop
using our Services.`
        },
        {
          id: 3,
          texts:
            "If you have any questions about these Terms or our Services, please contact us at help@snkrhud.com."
        }
      ],
      termstwo: [
        {
          id: 0,
          termtitle: "Definitions",
          texts: `
“Art” means any art, design, and drawings that may be associated with an NFT that you Own.
"NFT" means any blockchain-tracked, non-fungible token.
“Own” means, with respect to an NFT, an NFT that you have purchased or otherwise rightfully acquired
from a legitimate source, where proof of such purchase is recorded on the relevant blockchain.
“Extensions” means third party designs that: (i) are intended for use as extensions or overlays to the Art,
(ii) do not modify the underlying Art, and (iii) can be removed at any time without affecting the
underlying Art.
“Digital Collectible” is an NFT and any Extensions.
“Purchased NFT” means an NFT that you Own.
“Third Party IP” means any third party patent rights (including, without limitation, patent applications
and disclosures), copyrights, trade secrets, trademarks, know-how or any other intellectual property
rights recognized in any country or jurisdiction in the world.
`
        },
        {
          id: 1,
          termtitle: "License",
          texts: `
You acknowledge and agree that SNKRHUD (or, as applicable, its licensors) owns all legal right, title
and interest in and to the Art, and all intellectual property rights therein. The rights that you have in
and to the Art are limited to those described in this License. SNKRHUD reserves all rights in and to the
Art not expressly granted to you in this License.`
        },
        {
          id: 2,
          termtitle: "Ownership",
          texts: `
a. General Use. Subject to your continued compliance with the terms of this License, SNKRHUD grants
you a worldwide, non-exclusive, non-transferable, royalty-free license to use, copy, and display the Art
for your Purchased NFTs, along with any Extensions that you choose to create or use, solely for the
following purposes: (i) for your own personal, non-commercial use; (ii) as part of a marketplace that
permits the purchase and sale of your NFTs, provided that the marketplace cryptographically verifies
each NFT owner’s rights to display the Art for their Purchased NFTs to ensure that only the actual owner
can display the Art; or (iii) as part of a third party website or application that permits the inclusion,
involvement, or participation of your NFTs, provided that the website/application cryptographically
verifies each NFT owner’s rights to display the Art for their Purchased NFTs to ensure that only the
actual owner can display the Art, and provided that the Art is no longer visible once the owner of the
Purchased NFT leaves the website/application.

b. Commercial Use. Subject to your continued compliance with the terms of this License, SNKRHUD
grants you a limited, worldwide, non-exclusive, non-transferable license to use, copy, and display the
Art for your Purchased NFTs for the purpose of commercializing your own merchandise that includes,
contains, or consists of the Art for your Purchased NFTs (“Commercial Use”), provided that such
Commercial Use does not result in you earning more than Two Hundred Fifty Thousand Dollars
($250,000) in gross revenue each year. For the sake of clarity, nothing in this Section 3.b will be deemed
to restrict you from (i) owning or operating a marketplace that permits the use and sale of NFTs
generally, provided that the marketplace cryptographically verifies each NFT owner’s rights to display
the Art for their Purchased NFTs to ensure that only the actual owner can display the Art; (ii) owning or
operating a third party website or application that permits the inclusion, involvement, or participation
of NFTs generally, provided that the third party website or application cryptographically verifies each
NFT owner’s rights to display the Art for their Purchased NFTs to ensure that only the actual owner can
display the Art, and provided that the Art is no longer visible once the owner of the
Purchased NFT leaves the website/application; or (iii) earning revenue from any of the foregoing, even
where such revenue is in excess of $250,000 per year.
`
        },
        {
          id: 3,
          termtitle: "Restrictions",
          texts: `
You agree that you may not, nor permit any third party to do or attempt to do any of the foregoing
without SNKRHUD’s express prior written consent in each case: (i) modify the Art for your Purchased NFT
in any way, including, without limitation, the shapes, designs, drawings, attributes, or color schemes
(your use of Extensions will not constitute a prohibited modification hereunder); (ii) use the Art for your
Purchased NFTs to advertise, market, or sell any third party product or service; (iii) use the Art for your
Purchased NFTs in connection with images, videos, or other forms of media that depict hatred,
intolerance, violence, cruelty, or anything else that could reasonably be found to constitute hate
speech or otherwise infringe upon the rights of others; (iv) use the Art for your Purchased NFTs in
movies, videos, or any other forms of media, except to the limited extent that such use is expressly
permitted in Section 3(b) above or solely for your own personal, non-commercial use; (v) sell, distribute
for commercial gain (including, without limitation, giving away in the hopes of eventual commercial
gain), or otherwise commercialize merchandise that includes, contains, or consists of the Art for your
Purchased NFTs, except as expressly permitted in Section 3(b) above; (vi) attempt to trademark,
copyright, or otherwise acquire additional intellectual property rights in or to the Art for your
Purchased NFTs; or (vii) otherwise utilize the Art for your Purchased NFTs for your or any third party’s
commercial benefit. To the extent that Art associated with your Purchased NFTs contains Third Party IP
(e.g., licensed intellectual property from a celebrity, athlete, or other public figure), you understand
and agree as follows: (w) that you will not have the right to use such Third Party IP in any way except
as incorporated in the Art, and subject to the license and restrictions contained herein; (x) that the
Commercial Use license in Section 3(b) above will not apply; (y) that, depending on the nature of the
license granted from the owner of the Third Party IP, SNKRHUD may need to pass through additional
restrictions on your ability to use the Art; and (z) to the extent that SNKRHUD informs you of such
additional restrictions in writing (email is permissible), you will be responsible for complying with all
such restrictions from the date that you receive the notice, and that failure to do so will be deemed a
breach of this license. The restriction in Section 4 will survive the expiration or termination of this
License.`
        },
        {
          id: 4,
          termtitle: "Terms of License",
          texts: `
The license granted in Section 3 above applies only to the extent that you continue to Own the
applicable Purchased NFT. If at any time you sell, trade, donate, give away, transfer, or otherwise
dispose of your Purchased NFT for any reason, the license granted in Section 3 will immediately expire
with respect to those NFTs without the requirement of notice, and you will have no further rights in or
to the Art for those NFTs. If you exceed the $250,000 limitation on annual gross revenue set forth in
Section 3.b above, you will be in breach of this License, and must send an email to SNKRHUD at
help@snkrhud.com within fifteen (15) days, with the phrase “NFT License - Commercial Use” in the
subject line, requesting a discussion with SNKRHUD regarding entering into a broader license
agreement or obtaining an exemption (which may be granted or withheld in SNKRHUD’s sole and
absolute discretion). If you exceed the scope of the license grant in Section 3.b without entering into a
broader license agreement with or obtaining an exemption from SNKRHUD, you acknowledge and agree
that: (i) you are in breach of this License; (ii) in addition to any remedies that may be available to
SNKRHUD at law or in equity, the Creator may immediately terminate this License, without the
requirement of notice; and (iii) you will be responsible to reimburse SNKRHUD for any costs and
expenses incurred by SNKRHUD during the course of enforcing the terms of this License against you.`
        },
        {
          id: 5,
          termtitle: "NFT Creation",
          active: true,
          texts: `
You are solely responsible for your use of our Services and for any information you provide, including
compliance with applicable laws, rules, and regulations, as well as these Terms.
By using our Services in conjunction with creating, submitting, posting, promoting, or displaying
content, or by complying with SNKRHUD’s metadata standards in your metadata API responses, you
grant us a worldwide, non-exclusive, sublicensable, royalty-free license to use, copy, modify, and
display any content, including but not limited to text, materials, images, files, communications,
comments, feedback, suggestions, ideas, concepts, questions, data, or otherwise, that you submit or
post on or through our Services for our current and future business purposes, including to provide,
promote, and improve our Services. This includes any digital file, art, or other material linked to or
associated with any NFT’s that are displayed on our Services.
SNKRHUD does not claim that submitting, posting, or displaying this content on or through our Services
gives SNKRHUD any ownership of the content. We're not saying we own it. We're just saying we might

use it and show it off a bit.
You represent and warrant that you have, or have obtained, all rights, licenses, consents, permissions,
power and/or authority necessary to grant the rights granted herein for any content that you create,
submit, post, promote, or display on or through our Services. You represent and warrant that such
content does not contain material subject to copyright, trademark, publicity rights, or other
intellectual property rights, unless you have necessary permission or are otherwise legally entitled to
post the material and to grant SNKRHUD the license described above, and that the content does not
violate any laws.
SNKRHUD will take down works in response to Digital Millennium Copyright Act (“DMCA”) takedown
notices and/or other intellectual property infringement claims and will terminate a user's access to
our Services if the user is determined to be a repeat infringer. If you believe that your content has been
copied in a way that constitutes copyright or trademark infringement, or violates your publicity
or other intellectual property rights, please contact help@snkrhud.com.
For us to process your infringement claim regarding content on our Services, you must be the
rightsholder or someone authorized to act on behalf of the rightsholder. When contacting us, your
notice must include:
`,
          termdots: [
            {
              id: 0,
              text: `Identification of the copyrighted work(s), trademark, publicity rights, or other intellectual property
rights that you claim is being infringed;`
            },
            {
              id: 1,
              text: `Identification of the allegedly infringing material that is requested to be removed, including a
description of the specific location (i.e., urls) on our Services of the material claimed to be infringing,
so that we may locate the material;`
            },
            {
              id: 2,
              text:
                "Your contact information – at a minimum, your full legal name (not pseudonym) and email address;"
            },
            {
              id: 3,
              text: "A declaration that contains all of the following:",
              active: true,
              termdots1: [
                {
                  id: 0,
                  text: `              A statement that you have a good faith belief that use of the material in the manner 
complained of is not authorized by the intellectual property rights owner, its agent, or the law;`
                },
                {
                  id: 1,
                  text:
                    "              A statement that the information in the notice is accurate; and"
                },
                {
                  id: 2,
                  text: `              A statement under penalty of perjury that you are authorized to act on behalf of the 
intellectual property owner of the intellectual property that is allegedly being infringed.`
                }
              ]
            },
            {
              id: 4,
              text: `Your physical or electronic signature (of your full legal name).
Please note that we will forward your notice of intellectual property infringement, including your 
contact information, to the party who will have their content removed so they understand why it is no 
longer available on SNKRHUD and can also contact you to resolve any dispute.
`
            }
          ]
        },
        {
          id: 6,
          termtitle: "Eligibility",
          active: true,
          texts: `
In order to use our Services, you must meet the following eligibility criteria:`,
          termdots: [
            {
              id: 0,
              text: `You must not be located in a country that is subject to the United States government embargo, or 
that has been designated by the United States government as a "terrorist supporting" country.`
            },
            {
              id: 1,
              text:
                " You must not be listed on any United States government list of prohibited or restricted parties."
            },
            {
              id: 2,
              text: `You must be at least 13 years of age.
If you are under 18 years of age (or the age of legal majority where you live), you may use our Services 
only under the supervision of a parent or legal guardian who agrees to be bound by these Terms. If you 
are a parent or legal guardian of a user under the age of 18 (or the age of legal majority), you agree to 
be fully responsible for the acts or omissions of such user in relation to our Services. If you use our 
Services on behalf of another person or entity, (a) all references to "you" throughout these Terms will 
include that person or entity, (b) you represent that you are authorized to accept these Terms on that 
person’s or entity’s behalf, and (c) in the event you or the person or entity violates these Terms, both you 
and the person or entity agree to be responsible to us.
`
            }
          ]
        },
        {
          id: 7,
          termtitle: "Your User Account and Account Security",
          texts: `
You need to register for an account to access our Services. When you register for an account, you must 
provide accurate account information and promptly update this information if it changes. You also 
must maintain the security of your account and promptly notify us if you discover or suspect that 
someone has accessed your account without your permission. You must not permit others to use your 
account credentials. You are responsible for the activities of any users that occur in connection with 
your account. We reserve the right to reclaim usernames, including on behalf of businesses or 
individuals that hold legal claim, including trademark rights, in those usernames.

Access to your account is limited solely to you. You will not sell, rent, lease, or grant access to your 
account to any person without our prior written permission.

You are solely responsible for maintaining the security of your account and control over any 
usernames, passwords, or any other codes that you use to access our Services. You will not hold us 
responsible for managing and maintaining the security of your account. We are not responsible (and 
you will not hold us responsible) for any unauthorized access to or use of your account. You are 
responsible for monitoring your account. If you notice any unauthorized or suspicious activity in your 
account, please notify us immediately.`
        },
        {
          id: 8,
          termtitle: "Suspension of Account",
          texts: `
We have the right to immediately suspend your account, pause or cancel your access to our Services1, 
or close your account if we suspect, in our sole discretion, that (a) your account is being used for 
money laundering, to evade sanctions or to engage in illegal activity, (b) you have concealed or 
provided false identification information or other details, (c) you have engaged in fraudulent activity, 
or (d) you have engaged in transactions in violation of these Terms.
`
        },
        {
          id: 9,
          termtitle: "Trademarks",
          texts: `
SNKRHUD and our logos, our product or service names, our slogans and the look and feel of our Services 
are trademarks of SNKRHUD and may not be copied, imitated or used, in whole or in part, without our 
prior written permission. All other trademarks, registered trademarks, product names and company 
names or logos mentioned on our Services are the property of their respective owners. Reference to any 
products, services, processes or other information by trade name, trademark, manufacturer, supplier or 
otherwise does not constitute or imply endorsement, sponsorship or recommendation by us.`
        },
        {
          id: 10,
          termtitle: "Feedback",
          texts: `
You may voluntarily post, submit or otherwise communicate to us any questions, comments, 
suggestions, ideas, original or creative materials or other information about SNKRHUD or our Services 
(collectively, "Feedback"). We may use such Feedback for any purpose, commercial or otherwise, 
without acknowledgment or compensation to you, including, without limitation, to develop, copy, 
publish, or improve the Feedback in SNKRHUD’s sole discretion. You understand that SNKRHUD may treat 
Feedback as nonconfidential.`
        },
        {
          id: 11,
          termtitle: "Indemnification",
          texts: `
To the fullest extent permitted by applicable law, you will indemnify, defend and hold harmless 
SNKRHUD and our subsidiaries and affiliates, and each of our respective officers, directors, agents, 
partners and employees (individually and collectively, the "SNKRHUD Parties") from and against any 
losses, liabilities, claims, demands, damages, expenses or costs ("Claims") arising out of or related to 
(a) your access to or use of our Services; (b) your Feedback; (c) your violation of these Terms or the 
Digital Collectible Terms; (d) your violation, misappropriation or infringement of any intellectual 
property, privacy, or other rights of another; or (e) your conduct in connection with our Services. You will 
cooperate with the SNKRHUD Parties in defending such Claims and pay all fees, costs and expenses 
associated with defending such Claims (including, but not limited to, attorneys' fees). SNKRHUD Parties 
will have control of the defense or settlement, at SNKRHUD’s sole option, of any third-party Claims.`
        },
        {
          id: 12,
          termtitle: "Governing Law and Venue",
          texts: `
Any dispute arising from these Terms and your use of our Services will be governed by and construed 
and enforced in accordance with the laws of the State of New York without regard to conflict of law 
rules or principles that would cause the application of the laws of any other jurisdiction. Any dispute 
between the parties that is not subject to arbitration or cannot be heard in small claims court will be 
resolved in the state or federal courts located in the boroughs of Brooklyn (Kings County) or Manhattan 
(New York County) in the state of New York and you consent to jurisdiction and venue in such courts.
`
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/depreciated/styles/termsandcondition.scss";
</style>
